import { render, staticRenderFns } from "./CreateOrderWithoutPayment.vue?vue&type=template&id=512e81e7"
import script from "./CreateOrderWithoutPayment.vue?vue&type=script&lang=js"
export * from "./CreateOrderWithoutPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports